import { cn } from '@avanta/shared/utils/cn';
import {
  CHECKBOX_CHECKED,
  CHECKBOX_UNCHECKED,
} from 'pages/Appointments/AppointmentsReserve/styles';
import { PsychoCard } from '../PsychoCard';
import { type PsychoCheckboxProps } from './types';

export const PsychoCheckbox = ({
  psychologist,
  checked,
  showReadMoreButton = true,
  onCheckedChange,
}: PsychoCheckboxProps): React.ReactElement => {
  const handleToggle = (): void => {
    onCheckedChange(!checked);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      className="inline-flex cursor-pointer w-full"
    >
      <PsychoCard
        psychologist={psychologist}
        showReadMoreButton={showReadMoreButton}
        className={cn(
          'w-full rounded-xl',
          checked ? CHECKBOX_CHECKED : `${CHECKBOX_UNCHECKED} shadow-none hover:shadow-box-sm`
        )}
      />
    </div>
  );
};
